import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import { showHorizontalSizeSelectorSelector } from 'viewModel/selectors/testTarget/showHorizontalSizeSelectorSelector';

const { wrapHOC } = FrameworkUtils;

const fields = createStructuredSelector({
    showHorizontalSizeSelector: showHorizontalSizeSelectorSelector
});

const functions = {};

const withSwatchesDisplayProps = wrapHOC(connect(fields, functions));

export {
    fields, withSwatchesDisplayProps
};
